import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./UserForm.css";
import "/src/components/UI/Button/IconButton/IconButton.css";
import Form from "/src/components/form/Form";
import TextInput from "/src/components/UI/TextField/TextInput";
import Field from "/src/components/UI/Field/Field";
import Button from "/src/components/UI/Button/Button";
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import "/src/assets/css/polices.css";
import userService from "../../services/userService";
import UserFormType from "./UserFormType";
import Dropdown from "/src/components/UI/DropDown/DropDown";
import roleAdminService from "/src/features/administration/roles/services/roleAdminService";

function UserForm({ data, type }) {
    const navigate = useNavigate();
    const { register, handleSubmit, formState, watch, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            id: data?.id ?? "",
            email: data?.email ?? "",
            //is_active: data?.is_active ?? true,
            //is_verified: data?.is_verified ?? false,
        },
    });

    const dataType = UserFormType[type ? type : "create"];
    const { addUser, updateUser } = userService;
    const { getRoles, getUserRoles } = roleAdminService;
    const [file, setFile] = useState(data?.picture || data?.image || null);
    const [roles, setRoles] = useState([]);
    // A real "no role" choice instead of '' - '' collides with a role whose
    // id is 0 (Administrator) under the Dropdown component's loose equality
    // checks, which silently kept the dropdown stuck on no display value.
    const NO_ROLE = "__no_role__";
    const [selectedRoleId, setSelectedRoleId] = useState(NO_ROLE);

    useEffect(() => {
        const fetchRoles = async () => {
            const [rolesResponse, rolesError] = await getRoles();
            if (!rolesError) setRoles(rolesResponse || []);

            if (data?.id) {
                const [userRolesResponse, userRolesError] = await getUserRoles(data.id);
                if (!userRolesError) setSelectedRoleId((userRolesResponse || [])[0]?.id ?? NO_ROLE);
            }
        };
        fetchRoles();
    }, [data?.id]);

    const roleChoices = [
        { text: "No role", value: NO_ROLE },
        ...roles.map((role) => ({ text: role.name, value: role.id })),
    ];

    const onSubmit = async (formValues) => {
        const formData = new FormData();
        const payload = {
            email: formValues.email,
            role_ids: selectedRoleId !== NO_ROLE ? [selectedRoleId] : [],
        };

        //formData.append("is_active", formValues.is_active ? "true" : "false");
        //formData.append("is_verified", formValues.is_verified ? "true" : "false");

        const [response, error] = data?.id ? await updateUser(data.id, payload) : await addUser(payload);

        if (error !== null) {
            console.log(error);
            return;
        }

        const searchUrl = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));
        return navigate("/administration/users");
    };

    return (
        <Form className="user-form" onSubmit={handleSubmit(onSubmit)}>
            <Form.Title>{dataType.title}</Form.Title>
            <Form.Body className="user_form_body">
                <br />
                <div style={{ marginBottom: "15px" }}>
                    <Field listClassName="field_label_user_form" label="Email" />
                    <TextInput {...register("email", { required: true, minLength: 1 })} className="full-width text_input_user_form" placeholder="Choose your email" />
                </div>

                <div className="row_user_form_container">
                    <Field listClassName="field_label_user_form" label="Role" />
                    <Dropdown
                        name="role_id"
                        choices={roleChoices}
                        setValue={(name, value) => setSelectedRoleId(value)}
                        defaultChoice={selectedRoleId}
                        width="240px"
                    />
                </div>

                {/*
                     <div style={{ marginTop: "25px", display: "flex" }}>
                    <Field label="Select your language" listLabelClassName="titles-input"></Field>
                    <div style={{ marginLeft: "20%", marginTop: "2%" }}>
                        <Dropdown  {...register('language')} setValue={setValue} choices={languages} defaultChoice={type == "update" ? formData.values.language.slug.toLowerCase() : "fr"} width="165px"></Dropdown>
                    </div>
                    
                <div className="botForm-container">
                    <Field label="Enter a description" listLabelClassName="titles-input">
                        <TextArea style={{ height: '40px' }} {...register('description')}></TextArea>
                    </Field>
                </div>
                </div>
                <Form.Body className="user_form_body">
                    <div style={{ marginBottom: "15px" }}>
                        <Field listClassName="field_label_user_form" label="Email" />
                        <TextInput
                            {...register("email", { required: true, minLength: 1 })}
                            className="full-width text_input_user_form"
                            placeholder="Choose your email"
                        />
                    </div>

                    <div className="row_user_form_container">
                        <Field listClassName="field_label_user_form" label="Role" />
                        <Dropdown
                            {...register("role")}
                            name="role"
                            className="field_label_user_form"
                            choices={roleChoices}
                            setValue={setValue}
                            defaultChoice={watch("role") ?? data?.role ?? 1}

                        />
                    </div>
                    <br></br>
                    {/*
                <div className="row_user_form_container">
                    <Field  listClassName="field_label_user_form" label="Active" />
                    <Checkbox
                        name="is_active"
                        checked={watch("is_active")}
                        onChange={(event) => setValue("is_active", event.target.checked, { shouldDirty: true })}
                    />
                </div>

                <div className="row_user_form_container">
                    <Field listClassName="field_label_user_form" label="Verified" />
                    <Checkbox name="is_verified" checked={watch("is_verified")} onChange={(event) => setValue("is_verified", event.target.checked, { shouldDirty: true })} />
                </div>
                <br></br>
                */}

            </Form.Body>
            <Form.Buttons>
                <Button
                    type="submit"
                    label={dataType.send}
                    className="validate"
                    disabled={!formState.isValid || !watch("email")}
                />
            </Form.Buttons>
        </Form>
    );
}

export default UserForm;